import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import lang from '../../../lib/language';
import { IndividualExtendedInfoData } from '../../../lib/models/enroll';
import { RootState } from '../../../lib/store/index';

import Button from '../../../shared_components/Button/Button';

import styles from './ChangePassword.module.scss';

const ChangePasswordConfirmation = () => {
  const navigate = useNavigate();
  const individual = useSelector<RootState, IndividualExtendedInfoData | null>(
    (state: RootState) => state.crm.individualExtendedInfo,
  );

  return (
    <div className={styles.confirmationWrapper}>
      <h5 className={styles.emailTitle}>{lang.mobilePasswordChangeEmailTitle()}</h5>
      <div className={styles.messageSentEmail}>
        <span>{lang.mobilePasswordChangeEmailUnderlineHeading1()}</span>
        <span className={styles.email}>{individual?.email}</span>
        <span>{lang.mobilePasswordChangeEmailUnderlineHeading2()}</span>
      </div>
      <Button fullWidth onClick={() => navigate(-1)} className={styles.buttonConfirm}>
        {lang.commonOkay() }
      </Button>
    </div>
  );
};

export default ChangePasswordConfirmation;
